export { default } from './favorite-editor';
